module.exports = __webpack_public_path__ + "img/site-protegido.07cc8c4a.svg";